<template>
    <div>
        <div
            v-if="loading"
            style="min-height: 80vh"
        >
            <div class="spinLoader">
                <i class="ti-reload"></i>
            </div>
        </div>
    <div v-if="this.$config.sites[this.$config.moniker].scheme == 'multiple'">
        <div v-if="!loading">
            <h4>Current Month Sales</h4>
            <!--Stats cards-->
            <div class="row">
                <div
                    class="col-md-4 "
                    v-for="stats in statsCards"
                    :key="stats.title"
                >
                    <stats-card>
                        <div
                            class="icon-big text-center"
                            :class="`icon-${stats.type}`"
                            slot="header"
                        >
                            <i :class="stats.icon"></i>
                        </div>
                        <div
                            class="numbers"
                            slot="content"
                        >
                            <p>{{ stats.title }}</p>
                            {{ stats.value }}
                        </div>
                        <!--<div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ stats.footerText }}
          </div>-->

                    </stats-card>
                </div>
            </div>
</div>
</div>
            <!--Charts-->
            <div class="row">
                <div class="col-12">

                    <div class="row align-items-center">

                        <div class="col">
                            <h4 class="pt-0 d-inline-block">Monthly Sales Reports</h4>

                            <select
                                v-model="year"
                                class="form-control report-year-select"
                            >
                                <option v-for="years in activeYears">{{ years }}</option>
                            </select>
                        </div>
                    </div>

                    <table class="table">
                        <tr
                            class="report-row"
                            v-for="(month, index) in activeMonths"
                            :key="index"
                        >
                            <td class="">{{ month }} {{ year }}</td>
                            <td>
                                <a
                                    :href="$config.apiUrl + '/report/'+ $config.sites[$config.moniker].store_id + '/' + $config.moniker +'/'+ (index+1) +'/'+ year"
                                    class="report-download"
                                > <i class="ti-cloud-down"></i> Download PDF Report</a>

                            </td>
                            <td><a
                                    :href="$config.apiUrl + '/report/'+ $config.sites[$config.moniker].store_id + '/' + $config.moniker+'/'+ (index+1) +'/'+ year +'/csv'"
                                    class="report-download"
                                > <i class="ti-cloud-down"></i> Download CSV Report</a></td>

                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { StatsCard } from "@/components/index";
import Chartist from "chartist";
export default {
    components: {
        StatsCard,
    },

    data() {
        return {
            loading: true,
            data: {},
            year: moment().year(),
            currentYear: moment().year(),
            startYear: 2022,
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
        };
    },

    computed: {

        totalSales: function () {
            return this.data.data.month.orders;
        },

        statsCards: function () {
            return [
                {
                    type: "secondary",
                    icon: "ti-money",
                    title: "Sales",
                    value: this.data.data.month.total,
                },

                {
                    type: "secondary",
                    icon: "ti-shopping-cart-full",
                    title: "Orders",
                    value: this.data.data.month.orders,
                },

                {
                    type: "secondary",
                    icon: "ti-wallet",
                    title: "Average Order",
                    value: this.data.data.month.averageorder,
                },
            ];
        },

        store_start_year: function () {
            return moment(this.$config.sites[this.$config.moniker].start_date).isValid() ? moment(this.$config.sites[this.$config.moniker].start_date).year() : this.startYear;
        },

        store_start_month: function () {            
            return moment(this.$config.sites[this.$config.moniker].start_date).isValid() ? moment(this.$config.sites[this.$config.moniker].start_date).month() : 0;
        },

        activeYears: function () {
            //return 123;
            let years = [];
            for (var i = this.store_start_year; i <= this.currentYear; i++) {
                years.push(i);
            }
            return years;
        },

        activeMonths: function () {

            // Check for partial months in first year
            if (this.store_start_year == this.year) {
                if (this.store_start_year == this.year && this.store_start_month < 12) {
                    return this.months.slice(this.store_start_month, 12);
                }
            }

            // Check for partial months in this year
            if (this.year == this.currentYear) {
                return this.months.slice(0, moment().format("M"));
            }
            
            // Return all months
            return this.months;
        },
    },

    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    methods: {
        async fetchData() {
            const response = await fetch(
                this.$config.apiUrl + "/get-artist-current-sales/" + this.$config.moniker
            );
            this.data = await response.json();
            this.loading = false;
        },
    },

    mounted: function () {
       if (this.$config.sites[this.$config.moniker].scheme == 'multiple'){
            this.fetchData();
       } else {
                    this.loading = false;

       }

    },
};
</script>

<style>
.form-control.report-year-select {
    font-size: 20px;
    display: inline-block;
    width: auto;
}
</style>



